import {
    ProductDetailTabSection,
    ProductDetailTabTable,
    ProductDetailTabMetrics,
    emptyProductDetailColumns,
    type ProductDetailTabProps
} from "@/views/pages/productManagement/ProductDetailTabPrimitives";

export type orderInfoProps = ProductDetailTabProps;

/** goodsManagement / consignment / components / orderInfo：保留数据展示、编辑提交和父级事件回调。 */
export default function MigrationComponent(props: orderInfoProps) {
    return (
        <ProductDetailTabSection title="订单明细" className="order-info">
            <ProductDetailTabMetrics items={[{ label: "已售吨数（吨）", value: "--" }, { label: "已提货吨数（吨）", value: "--" }]} />
            <ProductDetailTabTable
                ariaLabel="订单明细"
                columns={emptyProductDetailColumns(["订单编号", "采购用户", "交易单价(元/吨)", "采购吨数(吨)", "预估金额(元)", "实收款(元)", "下单时间", "状态"])}
                data={props.items}
            />
            {props.children}
        </ProductDetailTabSection>
    );
}
